__webpack_require__.p = "/pokersquares/";